import { createSlice } from "@reduxjs/toolkit";
import moment from "moment";

const notificationSlice = createSlice({
  name: "notification",
  initialState: {
    list: [],
  },
  reducers: {
    setNotifications(state, action) { state.list = action.payload },
    setNewNotification(state, action) {
      const value = action.payload.split('/')
      if (value[3] === "none") return

      let data = {
        id: "",
        guid: "",
        readBy: [],
        type: "FAULT",
        title: value[3],
        mc: { guid: value[2], name: "" },
        created: moment().toISOString(),
      }
      state.list = [...state.list, data]
    },
  },
});

export const { setNotifications, setNewNotification } = notificationSlice.actions;
export default notificationSlice.reducer;
